var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 7C18.2893 7 15 10.2893 15 14.3333C15 17.089 16.5775 19.5855 19 20.8281V25.1693L16.7942 24.1406C15.5316 23.5513 14.0433 23.8332 13.0833 24.8385L11.0104 27.0104L19.1614 35.1615C19.9174 35.9175 20.9215 36.3333 21.9895 36.3333H29.6666C31.872 36.3333 33.6666 34.5387 33.6666 32.3333V25.6693C33.6666 23.7506 32.2994 22.0983 30.414 21.7396L25.6666 20.8385V20.8281C28.0891 19.5855 29.6666 17.089 29.6666 14.3333C29.6666 10.2893 26.3773 7 22.3333 7ZM22.3333 9.66667C24.9066 9.66667 27 11.76 27 14.3333C27 15.5666 26.501 16.7195 25.6666 17.5703V15.6667C25.6666 13.8293 24.1706 12.3333 22.3333 12.3333C20.496 12.3333 19 13.8293 19 15.6667V17.5703C18.1656 16.7195 17.6666 15.5666 17.6666 14.3333C17.6666 11.76 19.76 9.66667 22.3333 9.66667ZM22.3333 15C22.7013 15 23 15.2987 23 15.6667V23.0443L29.9166 24.3594C30.5446 24.478 31 25.0306 31 25.6693V32.3333C31 33.068 30.4013 33.6667 29.6666 33.6667H21.9895C21.6335 33.6667 21.2988 33.528 21.0468 33.276L14.7369 26.9661L15.013 26.6797C15.1836 26.5024 15.4453 26.4546 15.6666 26.5573L21.6666 29.3568V15.6667C21.6666 15.2987 21.9653 15 22.3333 15Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon3);
export default __webpack_public_path__ + "static/media/featureIcon-3.4f19783274eb3ce79c206edf641040db.svg";
export { ForwardRef as ReactComponent };